import { Component, OnInit, Input } from '@angular/core'
import { HelpersService } from '../../services/helpers/helpers.service'
@Component({
	selector: 'app-highlight-product',
	templateUrl: './highlight-product.component.html',
	styleUrls: ['./highlight-product.component.scss'],
})
export class HighlightProductComponent implements OnInit {
	@Input() data: any = {}

	constructor(private helpers: HelpersService,) {
    }

	removeLangFromRoute(url: any) {
        return this.helpers.removeLangFromRoute(url)
    }
	
	ngOnInit() {}
	
}
